<button type="button" kendoButton #anchor (click)="svc.onToggle()" themeColor="primary" class="k-button-icon" [svgIcon]="icons.settings"></button>

@if (svc.show) {
<kendo-popup [anchor]="anchor" [popupClass]="'content popup'" [anchorAlign]="svc.anchorAlign" [popupAlign]="svc.popupAlign">
  <div style="padding:10px;">
    <div>
      <button type="button" kendoButton themeColor="primary" [svgIcon]="icons.undo" (click)="svc.restoreColumns()"> Restore Defaults</button>
      <button type="button" kendoButton themeColor="primary" (click)="svc.exportToExcel(grid())" [svgIcon]="icons.export"> Export</button>
    </div>
    <br />
    <div class="grid-menu-container">
      <table class="k-grid-table grid-menu" role="presentation">
        <thead kendogridheader="">
          <tr kendogridlogicalrow="" role="row" aria-rowindex="1">
            <th aria-readonly="true" aria-selected="false" role="columnheader" class="k-header">
              Display
            </th>
            <th aria-readonly="true" aria-selected="false" role="columnheader" class="k-header">
              Frozen
            </th>
            <th aria-readonly="true" aria-selected="false" role="columnheader" class="k-header">
              Column
            </th>
          </tr>
        </thead>
        <colgroup kendogridcolgroup="" role="presentation">
          <col style="width: 30px;">
          <col style="width: 30px;">
        </colgroup>
        <tbody kendogridtablebody="" role="presentation">
          @for (col of filteredColumns; track col; let i = $index) {
          @if (col.params.display === true) {
          <tr [hidden]="col.params.type === 'row-select'" kendogridlogicalrow="" data-kendo-grid-item-index="0"
            role="presentation">
            <td aria-selected="false" kendogridcell="" kendogridlogicalcell="" role="gridcell">
              <input kendoCheckBox [ngModel]="!col.params.hide" (ngModelChange)="col.params.hide = $event" (change)="svc.hideChanged($event, i)" class="k-checkbox" [attr.id]="'cb-' + i + 'gm-sel'"
                type="checkbox" />
              <label class="k-checkbox-label" [attr.for]="'cb-' + i + 'gm-sel'"></label>
            </td>
            <td aria-selected="false" kendogridcell="" kendogridlogicalcell="" role="gridcell">
              <input kendoCheckBox [(ngModel)]="col.params.lock" (change)="svc.lockChanged($event, i)" class="k-checkbox" [attr.id]="'cb-' + i + 'gm-sel2'"
                type="checkbox" />
              <label class="k-checkbox-label" [attr.for]="'cb-' + i + 'gm-sel2'"></label>
            </td>
            <td aria-selected="false" kendogridcell="" kendogridlogicalcell="" role="gridcell">
              <span>{{col && col.title}}</span>
            </td>
          </tr>
          }
          }
        </tbody>
      </table>
    </div>
  </div>
</kendo-popup>
}